/* eslint-disable sonarjs/cognitive-complexity */
'use client';

import { EmptySubscription } from '@ahamove/icons/empty';
import { Box, Group, SimpleGrid, Skeleton, Text, rem } from '@mantine/core';
import { useTranslations } from 'next-intl';
import { useGetSubscriptionList } from '../api';
import SubscriptionItem from './subscription-item';
import { ResultBlock } from '@/components/result-block';
import {
  SubscriptionTab,
  useSubscriptionsStore,
} from '@/features/booking/store';
import useIsMobile from '@/lib/is-mobile/use-is-mobile';

export default function SubscriptionList() {
  const activeTab = useSubscriptionsStore.use.activeTab();

  const { data, isLoading } = useGetSubscriptionList({
    enabled: activeTab === SubscriptionTab.subscription,
    staleTime: 10 * 1000,
  });

  const tSubscription = useTranslations('subscription');
  const isMobile = useIsMobile();

  if (isLoading) {
    return (
      <Group
        px={isMobile ? rem(16) : rem(24)}
        gap={isMobile ? rem(8) : rem(16)}
      >
        {new Array(isMobile ? 3 : 6).fill(
          <Skeleton
            display={'block'}
            w={`calc(${isMobile ? '100%' : `50% - ${rem(8)}`})`}
            h={rem(112)}
            radius={rem(12)}
          />
        )}
      </Group>
    );
  }

  if (!data?.data?.length) {
    return (
      <ResultBlock
        className="justify-start p-[24px] md:p-0"
        icon={EmptySubscription}
        iconSize={160}
        description={
          <Text size={isMobile ? 'sm' : 'md'} c="neutral.6">
            {tSubscription('empty_list_description')}
          </Text>
        }
      />
    );
  }

  return (
    <>
      <Box
        pos="absolute"
        bg="linear-gradient(180deg, #FFF 8.18%, #FFEBDC 100%)"
        w="100%"
        h="100%"
        style={{ zIndex: 0 }}
      ></Box>
      <SimpleGrid
        pb={rem(24)}
        px={isMobile ? rem(16) : rem(24)}
        cols={isMobile ? 1 : 2}
        spacing={isMobile ? rem(8) : rem(16)}
        styles={{
          root: {
            zIndex: 1,
            position: 'relative',
          },
        }}
      >
        {data?.data.map((item, index) => (
          <SubscriptionItem
            key={item?._id || index}
            data={item}
            isHighlight={Boolean(index === 0)}
          />
        ))}
      </SimpleGrid>
    </>
  );
}
